import styled from "styled-components";

const Details = styled.div.attrs({
  className: "experience-details",
})``;

export default Details;
